var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WmButton, WmToggletip, WmDatepicker, WmTimepicker, } from "@watermarkinsights/ripple-react";
import { useEffect, useState, useRef } from "react";
import { closeFlyout, focusButtonComponent, isNullOrEmpty, openFlyout, } from "../../static/js/commons.js";
import { saveApplicationSchedule, updateApplicationSchedule, } from "./ApplicationSlice";
import translate from "../../i18n/translate";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import Inputfield from "../common/component/InputField";
import ScheduleOverlapModal from "./ScheduleOverlapModal";
import { applicationSelector } from "./ApplicationSlice";
import { format } from "date-fns";
import { formatDateInMMDDYYYY, convertTo12HourFormat, formatTimeInHHMM, } from "./util";
export default function ScheduleApplication({ setScheduleApplication, renderScheduleCard, scheduleObj, currentScheduleId, isActiveSchedule, }) {
    const dispatch = useDispatch();
    const titleRef = useRef();
    const { applicationSchedules, applicationSchedulesList } = useSelector(applicationSelector);
    const scheduleStartDate = new Date(scheduleObj === null || scheduleObj === void 0 ? void 0 : scheduleObj.startDate);
    const scheduleEndDate = (scheduleObj === null || scheduleObj === void 0 ? void 0 : scheduleObj.endDate)
        ? new Date(scheduleObj === null || scheduleObj === void 0 ? void 0 : scheduleObj.endDate)
        : "";
    const isEditSchedule = Object.keys(scheduleObj).length !== 0;
    const isPastScheduleStartDate = !isNullOrEmpty(scheduleObj === null || scheduleObj === void 0 ? void 0 : scheduleObj.startDate) &&
        scheduleStartDate.getTime() < new Date().getTime();
    const [scheduleTitleInput, setScheduleTitleInput] = useState((scheduleObj === null || scheduleObj === void 0 ? void 0 : scheduleObj.name) ? scheduleObj.name : "");
    const [modalOpen, setModalOpen] = useState(false);
    const [isTitleEmpty, setIsTitleEmpty] = useState(false);
    const [duplicateTitleError, setDuplicateTitleError] = useState(false);
    const [invalidDateOrTime, setInvalidDateOrTime] = useState(false);
    // Open Date State
    const [openDate, setOpenDate] = useState(() => formatDateInMMDDYYYY(scheduleStartDate));
    const [isOpenDateEmpty, setIsOpenDateEmpty] = useState(false);
    const [opendateError, setOpenDateError] = useState(false);
    const [opendateInvalidError, setOpenDateInvalidError] = useState(false);
    // Open Time State
    const [openTime, setOpenTime] = useState(() => formatTimeInHHMM(scheduleStartDate));
    const [isOpenTimeEmpty, setIsOpenTimeEmpty] = useState(false);
    const [openTimeError, setOpenTimeError] = useState(false);
    const [openTimeInvalidError, setOpenTimeInvalidError] = useState(false);
    // Close Date State
    const [closeDate, setCloseDate] = useState(() => scheduleEndDate instanceof Date ? formatDateInMMDDYYYY(scheduleEndDate) : "");
    const [isCloseDateEmpty, setIsCloseDateEmpty] = useState(false);
    const [closedateError, setCloseDateError] = useState(false);
    const [closeDateInvalidError, setCloseDateInvalidError] = useState(false);
    const [closedateBeforeOpenDateError, setClosedateBeforeOpenDateError] = useState(false);
    const [closedateTimeBeforeOpenDateTimeError, setClosedateTimeBeforeOpenDateTimeError,] = useState(false);
    // Close Time State
    const [closeTime, setCloseTime] = useState(() => scheduleEndDate instanceof Date ? formatTimeInHHMM(scheduleEndDate) : "");
    const [isCloseTimePast, setIsCloseTimePast] = useState(false);
    const [isCloseTimeEmpty, setIsCloseTimeEmpty] = useState(false);
    const [closeTimeInvalidError, setCloseTimeInvalidError] = useState(false);
    let errorCount;
    useEffect(() => {
        setTimeout(() => openFlyout("set-schedule-flyout", "schedule-app-btn", "input-schedule-title"), 200);
    }, []);
    const scheduleTitleLabel = useIntl().formatMessage({
        id: "app.programApplications.distribute.application.set.schedule.title",
    });
    const moreInfoLabel = useIntl().formatMessage({
        id: "app.programApplications.distribute.application.set.schedule.app.close.toggletip.moreInfoLabel",
    });
    const closeAppToggleTip = useIntl().formatMessage({
        id: "app.programApplications.distribute.application.set.schedule.app.close.toggletip",
    });
    const flyoutCloseToolTip = useIntl().formatMessage({
        id: "app.cohort.secondaryButtonText",
    });
    const emptyTitleErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.empty.title",
    });
    const duplicateTitleErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.duplicate.title",
    });
    const emptyDateErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.empty.date",
    });
    const emptyTimeErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.empty.time",
    });
    const pastDateErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.past.date",
    });
    const pastTimeErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.past.time",
    });
    const closeDateBeforeOpenDateErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.close.date.before.open.date",
    });
    const closeDateTimeBeforeOpenDateTimeErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.close.date.time.before.open.date.time",
    });
    const invalidDateErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.wrong.date.error.message",
    });
    const invalidTimeErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.schedule.wrong.time.error.message",
    });
    const closeFlyoutHandler = (event) => {
        event.preventDefault();
        setScheduleApplication(false);
        closeFlyout();
        if (isEditSchedule) {
            focusButtonComponent("edit-schedule-" + currentScheduleId);
        }
        else {
            focusButtonComponent("schedule-app-btn");
        }
    };
    const updateScheduleHandler = (event) => {
        event.preventDefault();
        setScheduleTitleInput(event.target.value);
        setIsTitleEmpty(false);
        setDuplicateTitleError(false);
    };
    const isTitleExist = (title) => {
        if (isEditSchedule) {
            let currentSched = [...applicationSchedulesList];
            currentSched.splice(currentScheduleId, 1);
            return currentSched.some((schedule) => schedule.name.trim() == title.trim() &&
                new Date(schedule.startDate) >= new Date() &&
                new Date(schedule.endDate) >= new Date());
        }
        return applicationSchedulesList.some((schedule) => schedule.name.trim() == title.trim() &&
            new Date(schedule.startDate) >= new Date() &&
            new Date(schedule.endDate) >= new Date());
    };
    const invalidChecksHandler = (errorCount) => {
        var _a;
        const timeInputs = document.querySelectorAll("wm-timepicker");
        timeInputs.forEach((timeInput) => {
            const isInvalid = timeInput.getAttribute("error-message");
            if (isInvalid) {
                errorCount += 1;
                setInvalidDateOrTime(true);
            }
            else {
                setInvalidDateOrTime(false);
            }
        });
        const dateInputs = document.querySelectorAll("wm-datepicker");
        dateInputs.forEach((dateInput) => {
            const isInvalid = dateInput.getAttribute("error-message");
            if (isInvalid) {
                errorCount += 1;
                setInvalidDateOrTime(true);
            }
            else {
                setInvalidDateOrTime(false);
            }
        });
        const dateTimeFields = document.querySelectorAll(".date-time-input");
        const firstInvalidInput = [...dateTimeFields].find((dtField) => dtField.getAttribute("error-message"));
        const focusId = firstInvalidInput === null || firstInvalidInput === void 0 ? void 0 : firstInvalidInput.getAttribute("id");
        if (focusId) {
            (_a = document.getElementById(focusId)) === null || _a === void 0 ? void 0 : _a.focus();
        }
        return errorCount;
    };
    const scheduleValidation = (errorCount) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const currentDate = new Date();
        const currentDateTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours(), currentDate.getMinutes());
        const currentDateObj = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const openDateVal = new Date(openDate);
        const openDateObj = new Date(openDateVal.getFullYear(), openDateVal.getMonth(), openDateVal.getDate());
        const openDateTime = new Date(openDateVal.getFullYear(), openDateVal.getMonth(), openDateVal.getDate(), isNullOrEmpty(openTime) ? 0 : parseInt(openTime.slice(0, 2)), isNullOrEmpty(openTime) ? 0 : parseInt(openTime.slice(3)));
        const closeDateVal = new Date(closeDate);
        const closeDateObj = new Date(closeDateVal.getFullYear(), closeDateVal.getMonth(), closeDateVal.getDate());
        const closeDateTime = new Date(closeDateVal.getFullYear(), closeDateVal.getMonth(), closeDateVal.getDate(), isNullOrEmpty(closeTime) ? 0 : parseInt(closeTime.slice(0, 2)), isNullOrEmpty(closeTime) ? 0 : parseInt(closeTime.slice(3)));
        errorCount = invalidChecksHandler(errorCount);
        if (scheduleTitleInput.trim() === "") {
            setIsTitleEmpty(true);
            (_a = document.getElementById("input-schedule-title")) === null || _a === void 0 ? void 0 : _a.focus();
            errorCount += 1;
        }
        else {
            setIsTitleEmpty(false);
        }
        if (isTitleExist(scheduleTitleInput)) {
            setDuplicateTitleError(true);
            (_b = document.getElementById("input-schedule-title")) === null || _b === void 0 ? void 0 : _b.focus();
            errorCount += 1;
        }
        else {
            setDuplicateTitleError(false);
        }
        if (openDate.trim() === "") {
            setIsOpenDateEmpty(true);
            errorCount += 1;
            if (scheduleTitleInput.trim() !== "" &&
                !isTitleExist(scheduleTitleInput)) {
                (_c = document.getElementById("open-date-picker")) === null || _c === void 0 ? void 0 : _c.focus();
            }
        }
        else {
            setIsOpenDateEmpty(false);
        }
        const isOpenDateInvalid = openDateObj < currentDateObj;
        if (isOpenDateInvalid && !isActiveSchedule) {
            setOpenDateError(true);
            (_d = document.getElementById("open-date-picker")) === null || _d === void 0 ? void 0 : _d.focus();
            errorCount += 1;
        }
        else {
            setOpenDateError(false);
        }
        if (openTime.trim() === "") {
            setIsOpenTimeEmpty(true);
            errorCount += 1;
            if (scheduleTitleInput.trim() !== "" &&
                !isTitleExist(scheduleTitleInput) &&
                openDate.trim() !== "") {
                (_e = document.getElementById("open-time-picker")) === null || _e === void 0 ? void 0 : _e.focus();
            }
        }
        else {
            setIsOpenTimeEmpty(false);
        }
        const isOpenTimeInvalid = openDateTime.getTime() < currentDateTime.getTime();
        if (!isOpenDateInvalid && isOpenTimeInvalid && !isActiveSchedule) {
            setOpenTimeError(true);
            (_f = document.getElementById("open-time-picker")) === null || _f === void 0 ? void 0 : _f.focus();
            errorCount += 1;
        }
        else {
            setOpenTimeError(false);
        }
        if (closeDate.trim() !== "" && closeTime.trim() === "") {
            setIsCloseTimeEmpty(true);
            errorCount += 1;
            if (scheduleTitleInput.trim() !== "" &&
                !isTitleExist(scheduleTitleInput) &&
                !isOpenDateEmpty &&
                !isOpenTimeEmpty &&
                !openTimeError &&
                !opendateError &&
                !invalidDateOrTime) {
                (_g = document.getElementById("close-time-picker")) === null || _g === void 0 ? void 0 : _g.focus();
            }
        }
        else {
            setIsCloseTimeEmpty(false);
        }
        if (closeTime.trim() !== "" && closeDate.trim() === "") {
            setIsCloseDateEmpty(true);
            if (scheduleTitleInput.trim() !== "" &&
                !isTitleExist(scheduleTitleInput) &&
                !isOpenDateEmpty &&
                !isOpenTimeEmpty &&
                !openTimeError &&
                !opendateError &&
                !invalidDateOrTime) {
                (_h = document.getElementById("close-date-picker")) === null || _h === void 0 ? void 0 : _h.focus();
            }
            errorCount += 1;
        }
        else {
            setIsCloseDateEmpty(false);
        }
        if (closeDateObj < currentDateObj) {
            setCloseDateError(true);
            (_j = document.getElementById("close-date-picker")) === null || _j === void 0 ? void 0 : _j.focus();
            errorCount += 1;
        }
        else {
            setCloseDateError(false);
        }
        if (new Date(closeDate).getTime() < new Date(openDate).getTime()) {
            setClosedateBeforeOpenDateError(true);
            (_k = document.getElementById("close-date-picker")) === null || _k === void 0 ? void 0 : _k.focus();
            errorCount += 1;
        }
        else {
            setClosedateBeforeOpenDateError(false);
        }
        if (closeTime.trim() !== "" &&
            openDateTime.getTime() >= closeDateTime.getTime()) {
            setClosedateTimeBeforeOpenDateTimeError(true);
            if (new Date(closeDate).getTime() >= new Date(openDate).getTime()) {
                (_l = document.getElementById("close-time-picker")) === null || _l === void 0 ? void 0 : _l.focus();
            }
            errorCount += 1;
        }
        else {
            setClosedateTimeBeforeOpenDateTimeError(false);
        }
        if (closeTime.trim() !== "" &&
            closeDateTime.getTime() <= currentDateTime.getTime()) {
            setIsCloseTimePast(true);
            if (new Date(closeDate).getTime() >= new Date(openDate).getTime()) {
                (_m = document.getElementById("close-time-picker")) === null || _m === void 0 ? void 0 : _m.focus();
            }
            errorCount += 1;
        }
        else {
            setIsCloseTimePast(false);
        }
        return errorCount;
    };
    const validateOpenDate = (event) => __awaiter(this, void 0, void 0, function* () {
        const datepicker = event.target;
        if (!datepicker.value) {
            setIsOpenDateEmpty(true);
            setOpenDateError(false);
            setOpenDateInvalidError(false);
            return;
        }
        setIsOpenDateEmpty(false);
        const isoDate = yield datepicker.reformatDate("US", "ISO", datepicker.value);
        if (yield datepicker.isValidIso(isoDate)) {
            const displayDate = yield datepicker.reformatDate("ISO", "US", isoDate);
            setOpenDate(displayDate);
            setOpenDateInvalidError(false);
        }
        else {
            datepicker.errorMessage = invalidDateErrorMessage;
            setOpenDateInvalidError(true);
        }
    });
    const handleOpenDateSelection = (event) => __awaiter(this, void 0, void 0, function* () {
        const datepicker = event.target;
        const selectedISODate = event.detail.date;
        datepicker.value = yield datepicker.reformatDate("ISO", "US", selectedISODate);
        datepicker.errorMessage = "";
        setOpenDate(datepicker.value);
        setIsOpenDateEmpty(false);
        setOpenDateError(false);
        setOpenDateInvalidError(false);
    });
    const getOpenDateErrorMessage = () => {
        if (isOpenDateEmpty) {
            return emptyDateErrorMessage;
        }
        if (opendateError) {
            return pastDateErrorMessage;
        }
        if (opendateInvalidError) {
            return invalidDateErrorMessage;
        }
        return "";
    };
    const validateOpenTime = (event) => __awaiter(this, void 0, void 0, function* () {
        const timepicker = event.target;
        if (!timepicker.value) {
            return;
        }
        if (yield timepicker.isValidTime(timepicker.value)) {
            const twelveHourTime = yield timepicker.reformatTime("24", timepicker.value);
            timepicker.errorMessage = "";
            timepicker.value = twelveHourTime;
            setOpenTime(timepicker.value);
            setOpenTimeError(false);
            setIsOpenTimeEmpty(false);
            setOpenTimeInvalidError(false);
        }
        else {
            timepicker.errorMessage = invalidTimeErrorMessage;
            setIsOpenTimeEmpty(false);
            setOpenTimeInvalidError(true);
        }
    });
    const handleOpenTimeSelection = (event) => __awaiter(this, void 0, void 0, function* () {
        const timepicker = event.target;
        const selectedTime = event.detail.time;
        const twelveHourSelectedTime = yield timepicker.reformatTime("24", selectedTime);
        timepicker.errorMessage = "";
        timepicker.preselected = selectedTime;
        timepicker.value = twelveHourSelectedTime;
        setOpenTime(timepicker.value);
        setOpenTimeError(false);
        setIsOpenTimeEmpty(false);
    });
    const getOpenTimeErroMessage = () => {
        if (isOpenTimeEmpty) {
            return emptyTimeErrorMessage;
        }
        if (openTimeError) {
            return pastTimeErrorMessage;
        }
        if (openTimeInvalidError) {
            return invalidTimeErrorMessage;
        }
        return "";
    };
    const validateCloseDate = (event) => __awaiter(this, void 0, void 0, function* () {
        const datepicker = event.target;
        if (!datepicker.value) {
            setCloseDateError(false);
            setCloseDateInvalidError(false);
            setClosedateBeforeOpenDateError(false);
            setClosedateTimeBeforeOpenDateTimeError(false);
            return;
        }
        setIsCloseDateEmpty(false);
        setCloseDateError(false);
        setClosedateBeforeOpenDateError(false);
        setClosedateTimeBeforeOpenDateTimeError(false);
        const isoDate = yield datepicker.reformatDate("US", "ISO", datepicker.value);
        if (yield datepicker.isValidIso(isoDate)) {
            const displayDate = yield datepicker.reformatDate("ISO", "US", isoDate);
            setCloseDate(displayDate);
            setCloseDateInvalidError(false);
        }
        else {
            datepicker.errorMessage = invalidDateErrorMessage;
            setCloseDateInvalidError(true);
        }
    });
    const handleCloseDateSelection = (event) => __awaiter(this, void 0, void 0, function* () {
        const datepicker = event.target;
        const selectedISODate = event.detail.date;
        datepicker.value = yield datepicker.reformatDate("ISO", "US", selectedISODate);
        datepicker.errorMessage = "";
        setCloseDate(datepicker.value);
        setCloseDateError(false);
        setClosedateBeforeOpenDateError(false);
        setIsCloseDateEmpty(false);
    });
    const getCloseDateErrorMessage = () => {
        if (isCloseDateEmpty) {
            return emptyDateErrorMessage;
        }
        if (closeDateInvalidError) {
            return invalidDateErrorMessage;
        }
        if (closedateError) {
            return pastDateErrorMessage;
        }
        if (closedateBeforeOpenDateError) {
            return closeDateBeforeOpenDateErrorMessage;
        }
        return "";
    };
    const validateCloseTime = (event) => __awaiter(this, void 0, void 0, function* () {
        const timepicker = event.target;
        if (!timepicker.value) {
            return;
        }
        if (yield timepicker.isValidTime(timepicker.value)) {
            const twelveHourTime = yield timepicker.reformatTime("24", timepicker.value);
            timepicker.errorMessage = "";
            timepicker.value = twelveHourTime;
            setCloseTime(timepicker.value);
            setClosedateTimeBeforeOpenDateTimeError(false);
            setIsCloseTimeEmpty(false);
            setIsCloseTimePast(false);
            setCloseTimeInvalidError(false);
        }
        else {
            timepicker.errorMessage = invalidTimeErrorMessage;
            setCloseTimeInvalidError(true);
        }
    });
    const handleCloseTimeSelection = (event) => __awaiter(this, void 0, void 0, function* () {
        const timepicker = event.target;
        const selectedTime = event.detail.time;
        const twelveHourSelectedTime = yield timepicker.reformatTime("24", selectedTime);
        timepicker.errorMessage = "";
        timepicker.preselected = selectedTime;
        timepicker.value = twelveHourSelectedTime;
        setCloseTime(timepicker.value);
        setClosedateTimeBeforeOpenDateTimeError(false);
        setIsCloseTimeEmpty(false);
        setIsCloseTimePast(false);
    });
    const getCloseTimeErroMessage = () => {
        if (isCloseTimeEmpty) {
            return emptyTimeErrorMessage;
        }
        if (closeTimeInvalidError) {
            return invalidTimeErrorMessage;
        }
        if (closedateTimeBeforeOpenDateTimeError) {
            return closeDateTimeBeforeOpenDateTimeErrorMessage;
        }
        if (isCloseTimePast) {
            return pastTimeErrorMessage;
        }
        return "";
    };
    const saveScheduleHandler = () => {
        errorCount = 0;
        let closeDateTime = null;
        let openDateTime = null;
        if (!isNullOrEmpty(openDate)) {
            const openDateVal = new Date(openDate);
            openDateTime = new Date(openDateVal.getFullYear(), openDateVal.getMonth(), openDateVal.getDate(), isNullOrEmpty(openTime) ? 0 : parseInt(openTime.slice(0, 2)), isNullOrEmpty(openTime)
                ? 0
                : isNaN(parseInt(openTime.slice(2)))
                    ? parseInt(openTime.slice(3))
                    : parseInt(openTime.slice(2)));
        }
        if (!isNullOrEmpty(closeDate)) {
            const closeDateVal = new Date(closeDate);
            closeDateTime = new Date(closeDateVal.getFullYear(), closeDateVal.getMonth(), closeDateVal.getDate(), isNullOrEmpty(closeTime) ? 0 : parseInt(closeTime.slice(0, 2)), isNullOrEmpty(closeTime)
                ? 0
                : isNaN(parseInt(closeTime.slice(2)))
                    ? parseInt(closeTime.slice(3))
                    : parseInt(closeTime.slice(2)));
        }
        errorCount = scheduleValidation(errorCount);
        if (errorCount === 0) {
            let newScheduleList = [
                ...applicationSchedulesList,
            ];
            if (isEditSchedule) {
                newScheduleList.splice(newScheduleList.findIndex((obj) => obj.uuid === scheduleObj.uuid), 1);
            }
            if (newScheduleList === null || newScheduleList === void 0 ? void 0 : newScheduleList.find((s) => {
                return ((new Date(s.startDate) <= openDateTime &&
                    openDateTime <= new Date(s.endDate)) || // if open date is between existing schedule's range
                    (new Date(s.startDate) <= closeDateTime &&
                        closeDateTime <= new Date(s.endDate)) || // if end date is between existing schedule's range
                    (new Date(s.startDate) < new Date() && isNullOrEmpty(s.endDate)) || // if there exists an active schedule with no end date
                    (isNullOrEmpty(closeDate) && openDateTime < new Date(s.endDate))); // if there exists a schedule and trying to create another one without end date
            })) {
                setModalOpen(true);
            }
            else if (!isNullOrEmpty(openDateTime)) {
                if (isEditSchedule) {
                    dispatch(updateApplicationSchedule({
                        name: scheduleTitleInput,
                        startDate: openDateTime === null || openDateTime === void 0 ? void 0 : openDateTime.toString(),
                        endDate: closeDateTime === null || closeDateTime === void 0 ? void 0 : closeDateTime.toString(),
                        currentScheduleId: currentScheduleId,
                    }));
                }
                else {
                    dispatch(saveApplicationSchedule({
                        name: scheduleTitleInput,
                        startDate: openDateTime === null || openDateTime === void 0 ? void 0 : openDateTime.toString(),
                        endDate: closeDateTime === null || closeDateTime === void 0 ? void 0 : closeDateTime.toString(),
                    }));
                }
                closeFlyoutHandler(event);
            }
        }
    };
    const renderFlyoutHeader = () => {
        return (_jsx("section", Object.assign({ className: "immersive-header header set-schedule-header" }, { children: _jsxs("div", Object.assign({ className: "page-header flex-row -justified -verticallycentered" }, { children: [_jsxs("div", { children: [_jsx("h6", Object.assign({ className: "flyout-header-label" }, { children: translate("app.programApplications.distribute.application.set.schedule.label") })), _jsx("h4", Object.assign({ className: "flyout-header-title" }, { children: translate("app.programApplications.distribute.application.set.schedule.header", { action: isEditSchedule ? "Edit" : "Add" }) }))] }), _jsx(WmButton, { buttonType: "navigational", icon: "close", tooltip: flyoutCloseToolTip, tooltipPosition: "bottom", id: "flyout-close", class: "hydrated", onClick: (event) => closeFlyoutHandler(event), placeholder: undefined })] })) })));
    };
    const renderMainContent = () => {
        return (_jsxs("section", Object.assign({ className: "schedule-app-body immersive-container" }, { children: [_jsxs("div", Object.assign({ className: "required-fields" }, { children: [translate("app.cohort.requiredText.prefix"), _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), translate("app.cohort.requiredText.suffix")] })), _jsx("p", Object.assign({ className: "schedule-app-infotext" }, { children: translate("app.programApplications.distribute.application.set.schedule.info.text") })), _jsx("div", Object.assign({ className: "schedule-title-input" }, { children: _jsx(Inputfield, { required: true, titleError: isTitleEmpty || duplicateTitleError, dataLabel: scheduleTitleLabel, modalTitle: scheduleTitleInput, updateTitleHandler: updateScheduleHandler, inputRef: titleRef, modalFor: "schedule-title", modalId: "schedule-title", customError: true, customErrorMessage: isTitleEmpty
                            ? emptyTitleErrorMessage
                            : duplicateTitleError
                                ? duplicateTitleErrorMessage
                                : "" }) })), _jsxs("div", Object.assign({ className: "schedule-app-open" }, { children: [_jsx("h5", Object.assign({ className: "set-schedule-label" }, { children: translate("app.programApplications.distribute.application.set.schedule.app.open", { keyword: isPastScheduleStartDate ? "Opened" : "Opens" }) })), _jsxs("div", Object.assign({ className: `schedule-date ${isPastScheduleStartDate ? "past-schedule-date" : ""}` }, { children: [_jsxs("label", Object.assign({ className: `textfieldlabel ${isOpenDateEmpty || opendateError ? "alert-label" : ""}`, htmlFor: "open-date-picker" }, { children: [translate("app.programApplications.distribute.application.schedule.date.label"), isPastScheduleStartDate ? "" : _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), (isOpenDateEmpty || opendateError) && (_jsx("span", { className: "alert-icon mdi mdi-alert" }))] })), isPastScheduleStartDate && scheduleObj.uuid ? (_jsx("p", Object.assign({ className: "past-date" }, { children: format(new Date(scheduleStartDate), "MM/dd/yyyy") }))) : (_jsx(WmDatepicker, { className: "date-time-input", labelPosition: "none", label: "Application Opens Date", id: "open-date-picker", dateFormat: "mm/dd/yyyy", value: openDate, onInput: (event) => setOpenDate(event.target.value), onWmDatepickerDateSelected: handleOpenDateSelection, onWmDatepickerInputBlurred: validateOpenDate, errorMessage: getOpenDateErrorMessage(), placeholder: undefined }))] })), _jsxs("div", { children: [_jsxs("label", Object.assign({ className: `textfieldlabel ${isOpenTimeEmpty || openTimeError ? "alert-label" : ""}`, htmlFor: "open-time-picker" }, { children: [translate("app.programApplications.distribute.application.schedule.time.label"), isPastScheduleStartDate ? "" : _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), (isOpenTimeEmpty || openTimeError) && (_jsx("span", { className: "alert-icon mdi mdi-alert" }))] })), isPastScheduleStartDate && scheduleObj.uuid ? (_jsx("p", Object.assign({ className: "past-time" }, { children: format(new Date(scheduleStartDate), "hh:mm a") }))) : (_jsx(WmTimepicker, { className: "date-time-input", labelPosition: "none", label: "Application Opens Time", id: "open-time-picker", value: convertTo12HourFormat(openTime), onWmTimepickerTimeSelected: handleOpenTimeSelection, onInput: (event) => setOpenTime(event.target.value), onWmTimepickerInputBlurred: validateOpenTime, errorMessage: getOpenTimeErroMessage(), placeholder: undefined }))] })] })), _jsxs("div", Object.assign({ className: "schedule-app-close" }, { children: [_jsx("h5", Object.assign({ className: "set-schedule-label" }, { children: translate("app.programApplications.distribute.application.set.schedule.app.closes") })), _jsx(WmToggletip, { id: "app-close-toggleTip", label: moreInfoLabel, tooltip: closeAppToggleTip, tooltipPosition: "top-right", placeholder: undefined }), _jsxs("div", Object.assign({ className: "schedule-date" }, { children: [_jsx("label", Object.assign({ className: `textfieldlabel ${isCloseDateEmpty || closedateError ? "alert-label" : ""}`, htmlFor: "close-date-picker" }, { children: translate("app.programApplications.distribute.application.schedule.date.label") })), _jsx(WmDatepicker, { className: "date-time-input", labelPosition: "none", label: "Application Closes Date", id: "close-date-picker", value: closeDate, onInput: (event) => setCloseDate(event.target.value), onWmDatepickerDateSelected: handleCloseDateSelection, onWmDatepickerInputBlurred: validateCloseDate, errorMessage: getCloseDateErrorMessage(), placeholder: undefined })] })), _jsxs("div", { children: [_jsx("label", Object.assign({ className: `textfieldlabel ${isCloseTimeEmpty || closeTimeInvalidError ? "alert-label" : ""}`, htmlFor: "close-time-picker" }, { children: translate("app.programApplications.distribute.application.schedule.time.label") })), _jsx(WmTimepicker, { className: "date-time-input", labelPosition: "none", label: "Application Closes Time", id: "close-time-picker", value: convertTo12HourFormat(closeTime), onInput: (event) => setCloseTime(event.target.value), onWmTimepickerTimeSelected: handleCloseTimeSelection, onWmTimepickerInputBlurred: validateCloseTime, errorMessage: getCloseTimeErroMessage(), placeholder: undefined })] })] }))] })));
    };
    const renderFlyoutFooter = () => {
        return (_jsx("footer", Object.assign({ className: "flyout-footer" }, { children: _jsxs("div", Object.assign({ className: "button-collection" }, { children: [_jsx(WmButton, Object.assign({ buttonType: "secondary", id: "cancel-btn", onClick: (event) => closeFlyoutHandler(event), placeholder: undefined }, { children: translate("app.programApplications.application.status.open.modal.secondary.text") })), _jsx(WmButton, Object.assign({ buttonType: "primary", id: "save-schedule", onClick: saveScheduleHandler, placeholder: undefined }, { children: translate("global.saveButtonText") }))] })) })));
    };
    return (_jsxs("div", Object.assign({ className: "flyout-panel half-flyout show", role: "dialog", id: "set-schedule-flyout", tabIndex: -1, "aria-label": "Set Schedule" }, { children: [_jsx("div", { className: "overlay" }), _jsxs("div", Object.assign({ className: "container" }, { children: [renderFlyoutHeader(), renderMainContent(), renderFlyoutFooter(), _jsx(ScheduleOverlapModal, { isOpen: modalOpen, onCloseClick: () => {
                            setModalOpen(false);
                            focusButtonComponent("save-schedule");
                        }, renderScheduleCard: renderScheduleCard })] }))] })));
}
